import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 画像表示用クラス
 *
 * @export
 * @class ImgaeInfoRenderComponent
 * @implements {OnChanges}
 */
@Component({
  selector: 'app-image-info-renderer',
  templateUrl: 'image-info-renderer.component.html',
  styleUrls: ['image-info-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ImgaeInfoRenderComponent implements OnChanges {

  /** データ */
  @Input() data: any;
  /** キャプション表示用 */
  @Input() imageFileName = String('');
  /**
   * 連携された値が変更された際に、メソッドを呼び出す
   *
   * @param {SimpleChanges} changes イベント引数
   * @memberof ImgaeInfoRenderComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'data':
          this.data = changes.data.currentValue;
          this.changeImageHandler();
          break;
      }
    });
  }

  /**
   * データ設定時
   *
   * @memberof ImgaeInfoRenderComponent
   */
  public changeImageHandler(): void {
    // 画像表示用キャプションのチェック
    if (!PlessViewUtilsSub.isEmpty(this.data.textCaption)) {
      // 指定ありの場合
      // 画像ファイル名を設定
      this.imageFileName = '★' + this.data.imageFileName;
    } else {
      // 指定なしの場合
      // 画像ファイル名を設定
      this.imageFileName = this.data.imageFileName;
    }
  }
}
